import {Component, Input, OnInit} from '@angular/core';
import {DiscountBenefit, Cart, DiscountEntry, DiscountType} from "../../../../common";

@Component({
  selector: 'voucher-entry',
  standalone: false,
  styles: [`
    discount-benefit {
      color: #28a745;
      font-style: italic;
      text-align: right;
    }

    :host-context(.list-group-item.active) discount-benefit {
      color: #fff !important;
    }
  `],
  template: `
    <div class="row">
      <div [ngClass]="{'col-11': reallyShowSelection, 'col-12': !reallyShowSelection}">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="flex-grow-1"><span i18n>Voucher</span><br><samp>{{ entry.discount.code }}</samp></div>
          <ng-content></ng-content>
          <div *ngIf="entry.amount">- {{ entry.amount|currency:cart.host }}</div>
          <discount-benefit class="flex-grow-1"
                            *ngFor="let benefit of benefits"
                            [cart]="cart" [benefit]="benefit"
                            [selections]="cart.benefitSelections"
                            [index]="0"
                            [pastTense]="pastTense"></discount-benefit>
        </div>
      </div>
      <div class="col-1 pl-0 pr-0 text-center" *ngIf="reallyShowSelection">
        <i class="fas fa-pencil-alt"></i>
      </div>
    </div>
  `
})

export class VoucherEntry implements OnInit {
  @Input() entry: DiscountEntry;
  @Input() pastTense: boolean = false;
  @Input() showSelection: boolean = false;
  DiscountType = DiscountType;
  reallyShowSelection: boolean;
  benefits: Array<DiscountBenefit>;
  cart: Cart;

  ngOnInit(): void {
    this.cart = this.entry.cart;
    this.reallyShowSelection = this.showSelection && this.entry.discount.needsSelection();
    this.benefits = this.entry.discount.benefits.filter(b=>!b.hasAmount());
  }
}
